import { render, staticRenderFns } from "./CommonJudgment.vue?vue&type=template&id=2f83bfa0&scoped=true"
import script from "./CommonJudgment.vue?vue&type=script&lang=js"
export * from "./CommonJudgment.vue?vue&type=script&lang=js"
import style0 from "./CommonJudgment.vue?vue&type=style&index=0&id=2f83bfa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f83bfa0",
  null
  
)

export default component.exports